import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import styles from './index.module.scss';
import cn from 'classnames';

const ConditionalBtnOrTextRenderer = ({ value }) => {
  const btnHandler = () => {
    value.btnData.onClick(value.itemData.id);
  };
  return (
    <span>
      {value.type === 'button' ? (
        <Button
          text={value.btnData.text}
          color={value.btnData.color}
          onClick={btnHandler}
          className={cn(styles.btn, value.btnData.className)}
        />
      ) : (
        <div>{value.data}</div>
      )}
    </span>
  );
};

ConditionalBtnOrTextRenderer.propTypes = {
  value: PropTypes.object,
};

export default ConditionalBtnOrTextRenderer;
